import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './PostValidationCard.module.css';
import * as routes from '../../../../constants/Routes';
import { IPostValidationPublication } from '../../../../interfaces/IPostValidation';

interface PostValidationCardProps {
  publication: IPostValidationPublication;
}

export function PostValidationCard({ publication }: PostValidationCardProps) {
  const navigate = useNavigate();
  const [imageFailed, setImageFailed] = useState(false);

  const networks = Object.values(publication.networks || {});
  const approvedCount = networks.filter((n) => n.status === 'approved').length;
  const totalNetworks = networks.length;
  const totalPoints = Object.values(publication.pointsPerSocialMedia || {})
    .filter((points): points is number => typeof points === 'number')
    .reduce((sum, points) => sum + points, 0);

  return (
    <div
      className="col-12 col-sm-12 col-md-6 col-lg-4"
      key={publication.id}
      id={publication.id}
    >
      <div className={styles.cardReveal}>
        <div className={styles.cardBanner}>
          {publication.image && !imageFailed ? (
            <img
              src={publication.image}
              alt={publication.title}
              onError={() => setImageFailed(true)}
            />
          ) : (
            <span className="material-icons-outlined">photo_camera</span>
          )}
        </div>
        <div className={`${styles.cardTitle} text-truncate p-4`}>
          <span
            style={{
              marginTop: '8px',
              marginBottom: '8px',
              fontWeight: 600,
              display: 'block',
            }}
          >
            {publication.title}
          </span>
          <span
            style={{
              marginTop: '8px',
              marginBottom: '8px',
              fontWeight: 500,
              display: 'block',
            }}
          >
            Até {totalPoints} pontos · {approvedCount}/{totalNetworks} redes
            validadas
          </span>
        </div>
        <div className={`${styles.cardAction} mt-4`}>
          <button
            className={styles.cta}
            onClick={() => {
              navigate(`${routes.POST_VALIDATION}/${publication.id}`);
            }}
          >
            <i className="material-icons-outlined mx-2">add</i>
            <span>Enviar print</span>
          </button>
        </div>
      </div>
    </div>
  );
}
